/* ----------------------------------------
    Imports
---------------------------------------- */

import { ApiService } from './ApiService';

/* ----------------------------------------
    Notification Service
---------------------------------------- */

export class NotificationService extends ApiService {

    /* ----------------------------------------
        Constructor
    ---------------------------------------- */

    protected constructor(store) {
        super('', store);
    }

    /* ----------------------------------------
        All
    ---------------------------------------- */

    public async getAll() {
        return this.get('/notification');
    }

    /* ----------------------------------------
        Read
    ---------------------------------------- */

    public async putRead(id: null|string = null) {
        id = (id === null) ? '' : id;
        return this.put(`/notification/${ id }`);
    }
}